import { lazy } from 'react';
import yn from 'Utils/ynToBool';
import React from 'react';

const fallback = null;
const Features = Object.freeze({
  widgets: lazy(() => import('Shared/Widgets')),
  ClarityWidget: yn(process.env.REACT_APP_CLARITY)
    ? null
    : fallback,
  RegulationComponent:
    process.env.REACT_APP_HAS_REGULATION_CUSTOM
      ? lazy(() => import(`${process.env.REACT_APP_HAS_REGULATION_CUSTOM}`))
      : lazy(() => import('components/Regulation/Pages/RegulationContainer')),
  TermsComponent:
    process.env.REACT_APP_HAS_TERMS_CUSTOM
      ? lazy(() => import(`${process.env.REACT_APP_HAS_TERMS_CUSTOM}`))
      : lazy(() => import('components/Terms/Pages/TermsContainer')),
  PrivacyComponent:
    process.env.REACT_APP_HAS_PRIVACY_CUSTOM
      ? lazy(() => import(`${process.env.REACT_APP_HAS_PRIVACY_CUSTOM}`))
      : lazy(() => import('components/Privacy/Pages/PrivacyContainer')),
  FaqComponent:
    process.env.REACT_APP_HAS_FAQ_CUSTOM
      ? lazy(() => import(`${process.env.REACT_APP_HAS_FAQ_CUSTOM}`))
      : lazy(() => import('components/FAQ/Pages/FaqContainer')),
});

export default Features;
